import { render, staticRenderFns } from "./ContainerMain.vue?vue&type=template&id=6fba259c&"
import script from "./ContainerMain.vue?vue&type=script&lang=js&"
export * from "./ContainerMain.vue?vue&type=script&lang=js&"
import style0 from "./ContainerMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports